/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * A list of proofs of a credential. [Terminology](https://www.w3.org/TR/vc-data-integrity/#proofs).
 */
export type CredentialProofs = Truvity.CredentialProof[];
